import { createClient } from '@supabase/supabase-js';

// Get environment variables from Create React App
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'placeholder-key';

// Check if using placeholder values
const isConfigured = 
  supabaseUrl !== 'https://placeholder.supabase.co' &&
  supabaseUrl !== 'https://your-project.supabase.co' &&
  supabaseAnonKey !== 'placeholder-key' &&
  supabaseAnonKey !== 'your-anon-key-here' &&
  supabaseUrl.includes('.supabase.co') &&
  supabaseAnonKey.length > 100;

console.log('🔧 Supabase Configuration:');
console.log('  URL:', supabaseUrl);
console.log('  Configured:', isConfigured);
console.log('  Key Length:', supabaseAnonKey.length);

if (!isConfigured) {
  console.error('❌ Supabase not configured properly!');
  console.error('📝 Current URL:', supabaseUrl);
  console.error('📝 Expected format: https://xxxxx.supabase.co');
  console.error('📝 Please check your .env file in the frontend folder');
  console.error('📝 Make sure to RESTART the server after updating .env');
} else {
  console.log('✅ Supabase configured successfully!');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
export const isSupabaseConfigured = isConfigured;
